module.exports = __webpack_public_path__ + "img/icon12.ee543ae2.ee543ae2.svg";